export default __webpack_public_path__ + "static/media/2.843666d7.webp";